// extracted by mini-css-extract-plugin
export default {"footer":"gnUzF1puvqGKkf5_6BOk","logo":"CcsIcTkBFVkbjmWT5RZp","container":"HxnsjQESj9tz6FOknLm8","links":"RFAI1wGAoqBdnR7INquA","name":"qO6yZrBqKw23VEZBrPsi"};